<template>
  <div>
    <VueApexCharts
      :options="halfHourChart.options"
      :series="props.seriesData"
      height="350"
    ></VueApexCharts>
  </div>
</template>

<script setup>
import { reactive, defineProps } from "vue";
import VueApexCharts from "vue3-apexcharts";

const props = defineProps({
  seriesData: {
    type: Array,
    required: false,
    default: () => []
  },
  // categories: {
  //   type: Array,
  //   required: false,
  // },
})

// * Bar Chart data
const halfHourChart = reactive({
  options: {
    chart: {
      height: 350,
      type: "area",
      //  data: "dates",
      toolbar: {
        show: true,
      },
    },
    xaxis: {
      // type: 'datetime',
      labels: {
        show: true,
        hideOverlappingLabels: true,
      }
    },
    stroke: {
      curve: "smooth",
      width: 2.5,
    },
    colors: ["#0c1e36", "#2B978D"],
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.25,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    markers: {
      size: 0,
    },
    yaxis: {
      labels: {
        show: true,
        formatter: function (val) {
          return val + " kWh";
        },
      },
    },
  },
});
</script>
